import React, { useState } from "react";
import { object, func } from "prop-types";
import { connect } from "react-redux";

import TextField from "../../atoms/TextField";
import Button from "../../atoms/button";

import { setMember } from "../../helper/actions";
import { getUserMetaData } from "../../utils/utils";
import { updateUserInformation, getUser } from "../../helper/api";

import "./mobileNumberUpdateView.m.css";

const MobileNumberUpdateView = ({ member, setLoading, setMember }) => {
  const [profile, setProfile] = useState(getUserMetaData(member));

  const setData = (e) => setProfile({ ...profile, mobileNumber: e.target.value });

  const saveProfileClick = () => {
    setLoading(true);

    updateUserInformation(profile)
      .then(() => {
        getUser().then((response) => setMember(response.member));
      })
      .catch((ex) => console.log(ex))
      .finally(() => setLoading(false));
  };

  return (
    <div styleName="wrapper">
      <span styleName="phone-no-required">Phone number is required for making payments</span>

      <div styleName="content">
        <TextField placeholder="Enter phone number here*" value={profile.mobileNumber} onChange={setData} />
        <Button content="Save & Proceed" buttonType="type2" onClick={saveProfileClick} />
      </div>
    </div>
  );
};

MobileNumberUpdateView.propTypes = {
  member: object,
  setLoading: func,
  setMember: func,
};

const mapDispatchToProps = (dispatch) => ({
  setMember: (member) => dispatch(setMember(member)),
});

export default connect(null, mapDispatchToProps)(MobileNumberUpdateView);
